import { render } from "./GuestPass.vue?vue&type=template&id=37897cd2&scoped=true"
import script from "./GuestPass.vue?vue&type=script&lang=js"
export * from "./GuestPass.vue?vue&type=script&lang=js"

import "./GuestPass.vue?vue&type=style&index=0&id=37897cd2&scoped=true&lang=css"

import exportComponent from "C:\\workspaces\\guest-pass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37897cd2"]])

export default __exports__